<template>
  <collapse-default :id="'dados-casamento'"
                    :collapse-visible="collapseVisible"
                    :condition="!!dados">
    <template v-slot:header>
      Dados Casamento  {{ !dados ? ' - Nenhum informado' : '' }}
    </template>
    <template v-slot:content>
      <div class="row p-3 py-2">
        <div class="col-2 col-sm-3">
          <label class="resumo-show_label"
                 for="">Data do Casamento</label>
          <div class="resumo-show_sublabel">
            {{ dados.data_casamento | date }}
          </div>
        </div>

        <div class="col-2 col-sm-3">
          <label class="resumo-show_label"
                 for="">Hora do Casamento</label>
          <div class="resumo-show_sublabel">
            {{ dados.hora_casamento | hour }}
          </div>
        </div>

        <div class="col-2 col-sm-3">
          <label class="resumo-show_label"
                 for="">Tipo de Casamento</label>
          <div class="resumo-show_sublabel">
            {{ dados.tipo_casamento || 'Não informado' }}
          </div>
        </div>

        <div class="col-2 col-sm-3">
          <label class="resumo-show_label"
                 for="">{{ (dados.tipo_casamento == 'Casamento Religioso com efeito civil' || dados.tipo_casamento == 'Religioso com efeito civil com Habilitação posterior') ? 'Celebrante' : 'Juíz' }} do Casamento</label>
          <div class="resumo-show_sublabel">
            {{ (dados.tipo_casamento == 'Casamento Religioso com efeito civil' || dados.tipo_casamento == 'Religioso com efeito civil com Habilitação posterior') ? dados.celebrante || 'Não informado' : dados.juiz || 'Não informado' }}
          </div>
        </div>
      </div>

      <div class="row p-3 py-2">
        <div class="col-2 col-sm-3">
          <label class="resumo-show_label"
                 for="">Regime de Bens</label>
          <div class="resumo-show_sublabel">
            {{ regimeDeBens[dados.regime_bens] || 'Não informado' }}
          </div>
        </div>
      </div>

      <div class="row p-3 py-2">
        <div class="col-12 col-sm-12">
          <label class="resumo-show_label"
                 for="">Complemento de Regime de Bens</label>
          <div class="resumo-show_sublabel">
            {{ dados.regime_bens_complemento || 'Não informado' }}
          </div>
        </div>
      </div>
    </template>
  </collapse-default>
</template>

<script>
  import CollapseDefault from "./CollapseDefault"

  export default {
    name: "DadosCasamentoCollapse",
    components: {
      CollapseDefault
    },
    props: {
      dados: {
        type: Object,
        default: () => ({})
      },
      collapseVisible: {
        type: Boolean,
        default: false
      },
    },
    data () {
      return {
        regimeDeBens: {
          'COMUNHAO_PARCIAL': "Comunhão parcial de bens" ,
          'COMUNHAO_UNIVERSAL': "Comunhão universal de bens",
          'PARTICIPACAO_FINAL_AQUESTOS': "Participação final aquestos" ,
          'SEPARACAO_BENS': "Separação de Bens" ,
          'SEPARACAO_LEGAL_BENS': "Separação legal de bens" ,
          'OUTROS': "Outros",
          'IGNORADO': "Ignorado"
        }
      }
    }
  }
</script>

<style scoped>

</style>
